import { useController } from "react-hook-form";
import { InfoTooltip } from "../Tooltips/InfoTooltip";
import { getNestedValue } from "../../helpers";
import { useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function Input(props) {
  const {
    label,
    type,
    name,
    id,
    placeholder,
    addOnRight,
    helper,
    control,
    infoText,
    disabled,
    className,
    inputSize = "xl",
    rules, // height
    ...rest
  } = props;

  const {
    field,
    formState: { errors },
  } = useController({
    name,
    control,
    rules,
  });

  const [showPassword, setShowPassword] = useState(false);
  const errorForField = getNestedValue(errors, name);

  const sizeClasses = {
    sm: "py-1 text-sm",
    md: "py-1.5 text-sm",
    lg: "py-2 text-base",
    xl: "py-3 text-base",
  };

  const isPasswordField = type === "password";
  const inputType = isPasswordField && showPassword ? "text" : type;

  return (
    <>
      <div className="flex justify-between">
        <label
          htmlFor={label}
          className="block text-sm font-light leading-6 text-gray-900 inline-flex items-center"
        >
          <span>{label}</span>
          {infoText && (
            <span className="ml-1">
              <InfoTooltip text={infoText} />
            </span>
          )}
        </label>
        {helper && (
          <span className="text-xs leading-6 text-gray-500">{helper}</span>
        )}
      </div>

      <div
        className={classNames(
          "mt-2 relative rounded-md",
          errorForField && "ring-red-300"
        )}
      >
        <input
          data-testid={name}
          type={inputType}
          onChange={field.onChange}
          onBlur={field.onBlur}
          value={field.value}
          name={field.name}
          ref={field.ref}
          id={id}
          className={classNames(
            "block w-full rounded-md border-0",
            sizeClasses[inputSize] || sizeClasses.md,
            errorForField
              ? "text-red-900 placeholder:text-red-300 ring-red-300 focus:ring-red-500"
              : "placeholder:text-gray-400 ring-gray-200 focus:ring-blue",
            "ring-1 ring-inset focus:ring-2 focus:ring-inset sm:leading-6",
            disabled && "bg-gray-100 ring-transparent",
            className
          )}
          placeholder={placeholder}
          disabled={disabled}
          {...rest} // no type override here anymore
        />

        {/* Right-side: password eye toggle OR addOnRight */}
        {(isPasswordField || addOnRight) && (
          <div className="absolute inset-y-0 right-0 flex items-center">
            {isPasswordField ? (
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="h-full px-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors focus:outline-none"
              >
                {showPassword ? (
                  <IoMdEyeOff size={20} />
                ) : (
                  <IoMdEye size={20} />
                )}
              </button>
            ) : typeof addOnRight === "string" ? (
              <div className="h-full flex items-center px-3 bg-gray-50 border border-gray-200 rounded-r-md">
                <span className="text-xs font-semibold uppercase tracking-wide text-gray-600">
                  {addOnRight}
                </span>
              </div>
            ) : (
              <div className="h-full flex items-center px-2">{addOnRight}</div>
            )}
          </div>
        )}
      </div>

      {errorForField && (
        <p className="mt-2 text-sm text-red-600" id={`${name}-error`}>
          {errorForField.message}
        </p>
      )}
    </>
  );
}
